import React from "react";

interface DocumentIconProps extends React.SVGProps<SVGSVGElement> {
    size?: number;
    color?: string;
    className?: string;
}

const DocumentIcon: React.FC<DocumentIconProps> = ({ size = 16, color = 'white', className, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M17.5 5.83332V14.1667C17.5 16.6667 16.25 18.3333 13.3333 18.3333H6.66667C3.75 18.3333 2.5 16.6667 2.5 14.1667V5.83332C2.5 3.33332 3.75 1.66666 6.66667 1.66666H13.3333C16.25 1.66666 17.5 3.33332 17.5 5.83332Z" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.0834 3.75V5.41667C12.0834 6.33333 12.8334 7.08333 13.75 7.08333H15.4167" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.66663 10.8333H9.99996" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.66663 14.1667H13.3333" stroke={color} strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />

    </svg>
);

export default DocumentIcon;
